import React, { useState, useEffect } from 'react'
import { Button, Col, Collapse, Form, Icon, Modal, Row, Table, Tooltip } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'
import { Formik } from 'formik'
import CustomInput from '../../components/CustomInput/customInput'
import { getMessage } from '../../util/IntlMessages'
import { api, request } from '../../util/handlerRequestUtil'

const { Panel } = Collapse
const INITIAL_FILTER = {
  nome: '',
  classificacao: ''
}

const ModalActionPlan = ({ locationId, customer, visible, onCancel, idSafra, setLoadCard, loadCard }) => {
  const [data, setData] = useState([])
  const [selectedCategory, setSelectedCategory] = useState('')
  const [categories, setCategories] = useState([])
  const [eibCategoriaAcoes, setEibCategoriaAcoes] = useState({})
  const [modalFilters, setModalFilters] = useState({ ...INITIAL_FILTER })
  const [formData, setFormData] = useState({ ...INITIAL_FILTER })

  useEffect(() => {
    setData([])
    fetchEibCategories({})
  }, [locationId])

  useEffect(() => {
    fetchEibCategoriaAcoes({
      nome: modalFilters.nome,
      classificacao: modalFilters.classificacao,
      categoria: selectedCategory.slice(-1)
    })
  }, [selectedCategory])

  useEffect(() => {
    filterCategories(formData)
  }, [locationId])

  const rowSelection = (panelIndex) => ({
    onChange: (selectedRowKeys, selectedRows) => {
      const newData = data.slice(0)
      newData[panelIndex] = selectedRows.map((selectedRow) => {
        return {
          idFazenda: +locationId,
          idAcaoEib: selectedRow.id,
          idsafra: +idSafra
        }
      })
      setData(newData)
    }
  })

  async function handleClickClearFilter() {
    setFormData({ ...INITIAL_FILTER })
    filterCategories({ ...INITIAL_FILTER })
  }

  async function filterCategories({ nome, classificacao }) {
    setModalFilters({ nome, classificacao })
    await fetchEibCategories({ nome, classificacao })
    if (locationId && selectedCategory) {
      await fetchEibCategoriaAcoes({ nome, classificacao })
    }
  }

  async function fetchEibCategories({ nome, classificacao }) {
    if (locationId) {
      const response = await request(
        api.getEibCategoriaByLocation(locationId, { nome, classificacao, available: true })
      )
      setCategories(response)
    }
  }

  async function fetchEibCategoriaAcoes({ nome, classificacao, categoria }) {
    const categories = categoria || selectedCategory
    if (locationId && categories) {
      const categoriesData = {}
      for (const category of categories) {
        let response = await request(
          api.getEibCategoriaAcoesByLocation(locationId, { nome, classificacao, categoria: category, available: true })
        )
        categoriesData[category] = response
      }
      setEibCategoriaAcoes({ ...eibCategoriaAcoes, ...categoriesData })
    }
  }

  async function storeEibLocationsPlain() {
    try {
      for (const eibLocationPlains of data) {
        if (eibLocationPlains) {
          for (const eibLocationPlain of eibLocationPlains) {
            var response = await request(api.createEibLocationsPlain(eibLocationPlain))
          }
        }
      }
      setLoadCard(!loadCard)
      if (response) {
        setLoadCard(!loadCard)
        onCancel()
      }
    } catch (err) {
      console.tron.log(err)
    }
  }

  function renderFilters() {
    return (
      <Formik initialValues={{}} onSubmit={() => {}}>
        {({ errors, setFieldValue }) => {
          const setFieldValueWithState = (field, value) => {
            setFormData({ ...formData, [field]: value })
            return setFieldValue(field, value)
          }
          return (
            <Form layout="vertical">
              <Row type="flex" justify="start" align="bottom">
                <CustomInput
                  labelInput={getMessage('filterActionCategoryOrName')}
                  field="nome"
                  errors={errors}
                  setFieldValue={setFieldValueWithState}
                  rowSpan={9}
                  value={formData}
                />
                <CustomInput
                  type="number"
                  labelInput={getMessage('categoryActionClassificationBayer')}
                  field="classificacao"
                  errors={errors}
                  setFieldValue={setFieldValueWithState}
                  rowSpan={5}
                  value={formData}
                />
                <Col span={5} style={{ paddingBottom: 20 }}>
                  <Button
                    icon="search"
                    className="bgPrimary"
                    style={{ width: '100%', marginTop: 24 }}
                    type="dashed"
                    onClick={() => filterCategories(formData)}
                  >
                    {getMessage('search')}
                  </Button>
                </Col>
                <Col span={5} style={{ paddingBottom: 20 }}>
                  <Button
                    icon="close"
                    style={{
                      width: '100%',
                      borderColor: '#EE778F',
                      color: '#EE778F',
                      marginTop: 24
                    }}
                    type="ghost"
                    onClick={handleClickClearFilter}
                  >
                    {getMessage('cleanFilters')}
                  </Button>
                </Col>
              </Row>
            </Form>
          )
        }}
      </Formik>
    )
  }

  return (
    <Modal
      title={getMessage('selectActions')}
      footer={null}
      onCancel={onCancel}
      width="75%"
      visible={visible}
      destroyOnClose={true}
    >
      {renderFilters()}
      <Collapse
        bordered={false}
        expandIcon={({ isActive }) => <Icon type="down" rotate={isActive ? 180 : 0} />}
        onChange={setSelectedCategory}
        className="custom-collapse"
      >
        {categories.length > 0 ? (
          categories.map((category, panelIndex) => (
            <Panel
              header={
                <Row>
                  <Col span={10}>{category.name}</Col>
                  <Col span={12} className="panel-header-info">
                    <Tooltip placement="topLeft" title={category.proposito}>
                      <InfoCircleOutlined /> {category.proposito}
                    </Tooltip>
                  </Col>
                </Row>
              }
              key={category.id}
            >
              <Table
                columns={[
                  {
                    title: 'Nome da ação',
                    dataIndex: 'name'
                  },
                  {
                    title: getMessage('categoryActionClassificationBayer'),
                    dataIndex: 'classificacao',
                    align: 'center',
                    render: (classificacao) => (
                      <>
                        <Icon type="star" /> {classificacao}
                      </>
                    )
                  }
                ]}
                dataSource={eibCategoriaAcoes[category.id]}
                pagination={false}
                rowSelection={rowSelection(panelIndex)}
                rowClassName={(record) => (record.classificacao > customer.eibClassificacao ? 'cl-danger' : '')}
              />
            </Panel>
          ))
        ) : (
          <h1
            style={{
              display: 'flex',
              alignItems: 'center',
              textAlign: 'center',
              justifyContent: 'center',
              marginTop: '40px',
              marginBottom: '40px'
            }}
          >
            Não existe Categoria/Ações com esse filtro
          </h1>
        )}
      </Collapse>
      <div className="customer-card-footer">
        <Button
          onClick={storeEibLocationsPlain}
          className="button button-action"
          type="primary"
          disabled={!data.length}
        >
          {getMessage('createCategoryActions')}
        </Button>
      </div>
    </Modal>
  )
}

export default ModalActionPlan
